// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/ImagensServicos_BuscaFotosResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for GET /config/imagens_servicos/busca_fotos/{id}/{antes_depois}
 *
 * Returns the list of "antes" or "depois" photos attached to a
 * compromisso_servico, with Azure Blob URLs (and SAS tokens for the
 * private container) appended by the controller.
 *
 * Legacy shape used `result->fotos`; this contract preserves that key.
 */
import type { ImagensServicos_FotoRow } from './ImagensServicos_FotoRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface ImagensServicos_BuscaFotosResponseDados {
fotos: ImagensServicos_FotoRow[]
}

export type ImagensServicos_BuscaFotosResponse = ApiResponse<ImagensServicos_BuscaFotosResponseDados>;

registerResponseContract('ImagensServicos_BuscaFotosResponse', {
  fotos: {
    type: 'array',
    required: true,
    items: {
      imagem_id:              { type: 'number',  required: true },
      imagem_nome:            { type: 'string',  required: true },
      compromisso_servico_id: { type: 'string',  required: false },
      antes_depois:           { type: 'string',  required: false },
      imagem_url:             { type: 'string',  required: false },
      imagem_thumbnail_url:   { type: 'string',  required: false },
    },
  },
})
